const loadedSrcs = new Set();

function execScript(oldScript) {
    return new Promise(resolve => {
        const src = oldScript.getAttribute('src');

        if (src && loadedSrcs.has(src)) {
            oldScript.remove();
            resolve();
            return;
        }

        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));

        if (src) {
            loadedSrcs.add(src);
            newScript.onload = () => resolve();
            newScript.onerror = () => resolve();
        } else {
            newScript.textContent = oldScript.textContent;
        }

        oldScript.parentNode.replaceChild(newScript, oldScript);

        if (!src) resolve();
    });
}

export async function runScripts(container) {
    const scripts = Array.from(container.querySelectorAll('script'));

    for (const script of scripts) {
        await execScript(script);
    }
}

export default runScripts;
